import React, { useState } from "react";
import { useAuth } from "react-oidc-context";
import MainApp from "./components/MainApp"; // Asegúrate de que este import sea correcto según tu estructura
import LoadingScreen from "./components/LoadingScreen";
import "./styles/theme.css";
import "./styles/Init.css";
import ocesaLogo from "./assets/logo_ocesa.png";
import { commercialSigninArgs } from "./CognitoConfig";

function App() {
  const auth = useAuth();
  const [loginPending, setLoginPending] = useState(false);
  const [loginError, setLoginError] = useState("");

  const login = async (commercial = false) => {
    if (loginPending) return;
    setLoginPending(true);
    setLoginError("");
    try {
      await auth.signinRedirect(commercial ? commercialSigninArgs : undefined);
    } catch {
      setLoginError("No pudimos iniciar el acceso. Intenta nuevamente.");
    } finally {
      setLoginPending(false);
    }
  };

  if (auth.isLoading) {
    return <LoadingScreen text="Validando credenciales..." />;
  }

  if (auth.error) {
    return (
      <div className="auth-error-page">
        <div className="auth-error-card">
          <div className="auth-error-logo">OCESA</div>

          <div className="auth-error-icon">!</div>

          <h1>No pudimos iniciar tu sesión</h1>

          <p className="auth-error-text">
            Hubo un problema al validar tus credenciales corporativas.
            Esto puede pasar si la sesión expiró, si no tienes permisos asignados
            o si hubo un error temporal de conexión.
          </p>

          <div className="auth-error-detail">
            <span>Detalle técnico:</span>
            <code>{auth.error.message || "Error de autenticación"}</code>
          </div>

          <div className="auth-error-actions">
            <button
              className="login-button"
              disabled={loginPending}
              onClick={() => login()}
            >
              Reintentar inicio de sesión
            </button>

            <button
              className="secondary-button"
              onClick={async () => {
                await auth.removeUser();
                window.location.reload();
              }}
            >
              Limpiar sesión
            </button>
          </div>

          {loginError && <p role="alert">{loginError}</p>}

          <p className="auth-error-help">
            Si el problema continúa, contacta al administrador de AI Coworker
            para validar tu acceso en Cognito.
          </p>
        </div>
      </div>
    );
  }

  if (auth.isAuthenticated && auth.user?.expired === false) {
    return <MainApp />;
  }

  return (
    <main className="login-page">
      <section
        className="login-card"
        aria-labelledby="login-title"
      >
        <div className="login-brand">
          <img
            src={ocesaLogo}
            alt="OCESA"
            className="login-brand-logo"
            draggable="false"
          />

          <span className="login-product">
            GAIA
          </span>
        </div>

        <div className="login-content">
          <span className="login-eyebrow">
            Portal corporativo
          </span>

          <h1 id="login-title">
            Inteligencia para tomar mejores decisiones
          </h1>

          <p className="login-description">
            Accede a tableros ejecutivos, reportes,
            datos y herramientas de inteligencia
            artificial de OCESA.
          </p>

          <button
            type="button"
            className="login-button login-button-main"
            disabled={loginPending}
            onClick={() => login()}
          >
            Iniciar Sesión Corporativa
          </button>

          <button
            type="button"
            className="secondary-button login-button-commercial"
            disabled={loginPending}
            onClick={() => login(true)}
          >
            Piloto Comercial
          </button>

          {loginError && <p role="alert">{loginError}</p>}

          <div className="login-security">
            <span
              className="login-security-dot"
              aria-hidden="true"
            />

            <span>
              Acceso exclusivo para usuarios autorizados.
            </span>
          </div>
        </div>

        <footer className="login-footer">
          <span>OCESA × AI Coworker</span>
          <span>Acceso monitoreado y auditado</span>
        </footer>
      </section>
    </main>
  );
}

export default App;
